var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgGengduo2 = function SvgGengduo2(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#333",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(6 5.9)"
  }, /*#__PURE__*/React.createElement("rect", {
    y: 3.35,
    width: 8,
    height: 1.3,
    rx: 0.65
  }), /*#__PURE__*/React.createElement("rect", {
    transform: "rotate(90 4 4)",
    y: 3.35,
    width: 8,
    height: 1.3,
    rx: 0.65
  })), /*#__PURE__*/React.createElement("path", {
    d: "M10 .35a9.65 9.65 0 1 0 0 19.3 9.65 9.65 0 0 0 0-19.3Zm0 1.3a8.35 8.35 0 1 1 0 16.7 8.35 8.35 0 0 1 0-16.7Z",
    fillRule: "nonzero"
  }))));
};

export default SvgGengduo2;